import React, { useEffect, useState } from "react";
import { useReactTable, flexRender, getCoreRowModel, getFilteredRowModel, getSortedRowModel, getPaginationRowModel, getFacetedRowModel } from "@tanstack/react-table";
import { fuzzyFilter, fuzzySort, TableFilter } from "./components/Filter";

export const AdvancedTable = ({ rows, cols, eventLabels, environment, updateEventLabels }) => {
    const [options, setOptions] = useState({
        columns: cols,
        data: rows,
        filterFns: {
            fuzzy: fuzzyFilter,
        },
        sortingFns: {
            fuzzy: fuzzySort,
        },
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSortedRowModel: getSortedRowModel(),
        // getPaginationRowModel: getPaginationRowModel(),
        getFacetedRowModel: getFacetedRowModel(),
    });
    useEffect(() => {
        setOptions({ ...options, data: rows, columns: cols })
    }, [rows, cols])
   
    const table = useReactTable(options)
    return <table>
        <thead>
            {table.getHeaderGroups().map(headerGroup => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map(header => (
                        <th key={header.id} colSpan={header.colSpan}>
                            {header.isPlaceholder ? null : (
                                <>
                                    <div
                                        {...{
                                            className: header.column.getCanSort()
                                                ? 'cursor-pointer select-none'
                                                : '',
                                            onClick: header.column.getToggleSortingHandler(),
                                        }}
                                    >
                                        {flexRender(
                                            header.column.columnDef.header,
                                            header.getContext()
                                        )}
                                        {{
                                            asc: ' 🔼',
                                            desc: ' 🔽',
                                        }[header.column.getIsSorted()] ?? null}
                                    </div>
                                    {header.column.getCanFilter() ? (
                                        <div>
                                            <TableFilter column={header.column} table={table} eventLabels={eventLabels} environment={environment} updateEventLabels={updateEventLabels} />
                                        </div>
                                    ) : null}
                                </>
                            )}
                        </th>
                    ))}
                </tr>
            ))}
        </thead>
        <tbody>
            {table.getRowModel().rows.map(row => {
                return (
                    <tr key={row.id}>
                        {row.getVisibleCells().map(cell => (

                            <td key={cell.id} style={{ textAlign: cell.column.columnDef.hozAlign }}>
                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </td>
                        ))}
                    </tr>
                )
            })}
        </tbody>
    </table>;
};
